import { render } from "./ExampleDeviceScreenVideo.vue?vue&type=template&id=7e8b665d&scoped=true&ts=true&lang=pug"
import script from "./ExampleDeviceScreenVideo.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExampleDeviceScreenVideo.vue?vue&type=script&lang=ts&setup=true"

import "./ExampleDeviceScreenVideo.vue?vue&type=style&index=0&id=7e8b665d&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e8b665d"]])

export default __exports__